export const dashboardDe = {
  // gemeinsam — DashboardNav
  'dashboard.nav.ariaLabel': 'Dashboard-Bereiche',
  'dashboard.nav.overview': 'Übersicht',
  'dashboard.nav.avatar': 'Avatar',
  'dashboard.nav.coins': 'Münzen',
  'dashboard.nav.contributions': 'Beiträge',

  // gemeinsam — StatusBadge (Beitragsstatus)
  'dashboard.status.draft': 'Entwurf',
  'dashboard.status.submitted': 'Eingereicht',
  'dashboard.status.communityReview': 'Community-Prüfung',
  'dashboard.status.officialReview': 'Offizielle Prüfung',
  'dashboard.status.approved': 'Angenommen',
  'dashboard.status.rejected': 'Abgelehnt',
  'dashboard.status.unknown': 'unbekannt',

  // gemeinsam — ClaimStatusBadge
  'dashboard.claimStatus.pending': 'ausstehend',
  'dashboard.claimStatus.approved': 'angenommen',
  'dashboard.claimStatus.rejected': 'abgelehnt',

  // DashboardPage
  'dashboard.seo.title': 'Mein Grymwyrd',
  'dashboard.seo.description': 'Deine Münzen, Ansprüche, Beiträge und Charaktere im ewigen Zwielicht.',
  'dashboard.displayNameFallback': 'Wanderer',
  'dashboard.welcomeBack': 'Willkommen zurück',
  'dashboard.editAvatar': 'Avatar bearbeiten',
  'dashboard.loading': 'Deine Legende wird gesammelt…',
  'dashboard.avatarAlt': 'Bildnis von {name}',
  'dashboard.offlineNotice':
    'Live-Profildaten sind nicht verfügbar — es werden deine zuletzt bekannte Sitzung und Beispielinhalte angezeigt.',

  // DashboardPage — Münzen-Karte
  'dashboard.coins.title': 'Grabmünzen',
  'dashboard.coins.viewAll': 'Alle ansehen',
  'dashboard.coins.unit': 'Münzen',
  'dashboard.coins.noActivity': 'Noch keine Münzaktivität.',
  'dashboard.coins.fullHistory': 'Vollständiger Verlauf & Münzen kaufen',

  // DashboardPage — Beiträge-Karte
  'dashboard.contributions.title': 'Beiträge',
  'dashboard.contributions.manage': 'Verwalten',
  'dashboard.contributions.empty': 'Noch keine Beiträge — verfasse deinen ersten.',

  // DashboardPage — Ansprüche-Karte
  'dashboard.claims.title': 'Beanspruchte Weltenorte',
  'dashboard.claims.empty': 'Noch hältst du keinen Boden in Grymwyrd.',
  'dashboard.claims.kindClaimed': '{kind} · beansprucht am {date}',

  // DashboardPage — Charaktere-Karte
  'dashboard.characters.title': 'Charaktere',
  'dashboard.characters.empty': 'Keine Seelen sind an deinen Namen gebunden.',
  'dashboard.characters.level': 'Stufe {level}',
  'dashboard.characters.unknown': 'Unbekannt',

  // AvatarEditorPage
  'dashboard.avatarEditor.seo.title': 'Avatar-Editor',
  'dashboard.avatarEditor.seo.description': 'Forme das Gesicht, das du der Welt von Grymwyrd zeigst.',
  'dashboard.avatarEditor.heading': 'Avatar-Editor',
  'dashboard.avatarEditor.errorNotImage': 'Diese Datei ist kein Bild.',
  'dashboard.avatarEditor.errorNameRequired': 'Ein Name ist nötig, selbst in der Finsternis.',
  'dashboard.avatarEditor.portrait': 'Bildnis',
  'dashboard.avatarEditor.portraitPreview': 'Bildnis-Vorschau',
  'dashboard.avatarEditor.avatarPreviewAlt': 'Avatar-Vorschau',
  'dashboard.avatarEditor.zoom': 'Zoom',
  'dashboard.avatarEditor.zoomAria': 'Bildnis zoomen',
  'dashboard.avatarEditor.panHorizontal': 'Bildnis waagerecht verschieben',
  'dashboard.avatarEditor.panVertical': 'Bildnis senkrecht verschieben',
  'dashboard.avatarEditor.uploadAria': 'Bildnis hochladen',
  'dashboard.avatarEditor.changeImage': 'Bild ändern',
  'dashboard.avatarEditor.uploadImage': 'Bild hochladen',
  'dashboard.avatarEditor.identity': 'Identität',
  'dashboard.avatarEditor.displayName': 'Anzeigename',
  'dashboard.avatarEditor.backstory': 'Vorgeschichte',
  'dashboard.avatarEditor.backstoryPlaceholder': 'Woher kamst du, und welchem dunklen Schicksal eilst du entgegen?',
  'dashboard.avatarEditor.publicProfile': 'Öffentliches Profil',
  'dashboard.avatarEditor.publicVisible': 'Sichtbar in der Halle der Legenden.',
  'dashboard.avatarEditor.publicHidden': 'Verborgen vor anderen Wanderern.',
  'dashboard.avatarEditor.saving': 'Wird gespeichert…',
  'dashboard.avatarEditor.saveChanges': 'Änderungen speichern',
  'dashboard.avatarEditor.saved': 'Gespeichert',

  // CoinHistoryPage
  'dashboard.coinHistory.checkoutUnavailable': 'Der Kassenvorgang ist noch nicht verfügbar — die Truhen bleiben verschlossen.',
  'dashboard.coinHistory.notEnoughCoins': 'Dafür reichen deine Münzen nicht.',
  'dashboard.coinHistory.reasonWorldClaim': 'Weltanspruch',
  'dashboard.coinHistory.reasonCosmetic': 'Kosmetik',
  'dashboard.coinHistory.spendReason': '{category} — {name}',
  'dashboard.coinHistory.spentNotice': '{cost} Münzen für {name} ausgegeben.',
  'dashboard.coinHistory.seo.title': 'Grabmünzen',
  'dashboard.coinHistory.seo.description': 'Dein vollständiges Münzbuch, Aufladungen und die Waren der Toten.',
  'dashboard.coinHistory.heading': 'Grabmünzen',
  'dashboard.coinHistory.balance': 'Guthaben',
  'dashboard.coinHistory.buyCoins': 'Münzen kaufen',
  'dashboard.coinHistory.packCoins': '{coins} Münzen',
  'dashboard.coinHistory.packBonus': ' + {bonus} Bonus',
  'dashboard.coinHistory.summoningCheckout': 'Kassenvorgang wird beschworen…',
  'dashboard.coinHistory.purchase': 'Kaufen',
  'dashboard.coinHistory.spendCoins': 'Münzen ausgeben',
  'dashboard.coinHistory.insufficientCoins': 'Nicht genug Münzen',
  'dashboard.coinHistory.spending': 'Wird ausgegeben…',
  'dashboard.coinHistory.spendAmount': '{cost} ausgeben',
  'dashboard.coinHistory.historyTitle': 'Verlauf',
  'dashboard.coinHistory.tallyingLedger': 'Das Münzbuch wird ausgezählt…',
  'dashboard.coinHistory.tableCaption': 'Verlauf der Münztransaktionen',
  'dashboard.coinHistory.colReason': 'Grund',
  'dashboard.coinHistory.colAmount': 'Betrag',
  'dashboard.coinHistory.noTransactions': 'Noch keine Transaktionen.',

  // ContributionsPage
  'dashboard.contributionsPage.seo.title': 'Meine Beiträge',
  'dashboard.contributionsPage.seo.description':
    'Die Überlieferungen, die du verfasst hast, und ihr Weg durch den Blick der Moderatoren.',
  'dashboard.contributionsPage.heading': 'Beiträge',
  'dashboard.contributionsPage.newContribution': 'Neuer Beitrag',
  'dashboard.contributionsPage.loading': 'Deine Schriftrollen werden entrollt…',
  'dashboard.contributionsPage.empty': 'Du hast noch keine Überlieferung verfasst. Beginne deinen ersten Beitrag.',
  'dashboard.contributionsPage.untitledDraft': 'Unbenannter Entwurf',
  'dashboard.contributionsPage.moderator': 'Moderator:',
  'dashboard.contributionsPage.entryFallback': 'Eintrag',
  'dashboard.contributionsPage.errorNameRequired': 'Jede Schöpfung braucht einen Namen.',
  'dashboard.contributionsPage.modalTitle': 'Neuer Beitrag',
  'dashboard.contributionsPage.type': 'Typ',
  'dashboard.contributionsPage.titleLabel': 'Titel',
  'dashboard.contributionsPage.summaryLabel': 'Zusammenfassung',
  'dashboard.contributionsPage.saveDraft': 'Entwurf speichern',
  'dashboard.contributionsPage.submitting': 'Wird eingereicht…',
  'dashboard.contributionsPage.submitForReview': 'Zur Prüfung einreichen',
}
